import { render, staticRenderFns } from "./severAgreement.vue?vue&type=template&id=76c21202&scoped=true&"
import script from "./severAgreement.vue?vue&type=script&lang=js&"
export * from "./severAgreement.vue?vue&type=script&lang=js&"
import style0 from "./severAgreement.vue?vue&type=style&index=0&id=76c21202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c21202",
  null
  
)

export default component.exports